import { FC, useCallback } from 'react';
import { CampaignCarousel } from '~/components/campaign-carousel';
import { ViewTracker } from '~/components/view-tracker';
import { ClickPosition } from '~/utils/click-position';
import { ModuleType } from '~/utils/module-type';
import { $CampaignBanner } from 'shared/atoms/common/campaign-banner';
import { useAtomValue } from 'jotai';

import './style.scss';

export const DiscoverCampaignSection: FC = () => {
  const campaigns = useAtomValue($CampaignBanner);

  const sendTrackingEvent = useCallback(() => {
    window.Tea('wap_cta_show', {
      current_page_module: ModuleType.activity_banner,
      current_position: ClickPosition.activity_banner,
    });
  }, []);

  if (!campaigns.length) {
    return null;
  }

  return (
    <ViewTracker key="discover-campaign" onView={sendTrackingEvent}>
      <section id="discover-campaign">
        <CampaignCarousel />
      </section>
    </ViewTracker>
  );
};
